import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from 'app/core/services/auth-guard-with-forced-login.service';

export const appRoutes: Routes = [
  // home
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // customer-area
  {
    path: 'customer-area/home',
    loadChildren: () => import('./pages/customer-area/home-customer/home-customer.module').then((m) => m.HomeCustomerModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'customer-area/invoice',
    loadChildren: () => import('./pages/customer-area/invoice/invoice.module').then((m) => m.InvoiceModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'customer-area/preview',
    loadChildren: () => import('./pages/customer-area/preview/preview.module').then((m) => m.PreviewModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'customer-area/production-flow',
    loadChildren: () => import('./pages/customer-area/production-flow/production-flow.module').then((m) => m.ProductionFlowModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'customer-area/rate',
    loadChildren: () => import('./pages/customer-area/rate/rate.module').then((m) => m.RateModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // laboratory-area
  {
    path: 'account',
    loadChildren: () => import('./pages/laboratory-area/account/account.module').then((m) => m.AccountModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'application-settings',
    loadChildren: () =>
      import('./shared/components/application-settings/application-settings.module').then((m) => m.ApplicationSettingsModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'customer',
    loadChildren: () => import('./pages/laboratory-area/customer/customer.module').then((m) => m.CustomerModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'file-asset',
    loadChildren: () => import('./pages/laboratory-area/file-asset/file-asset.module').then((m) => m.FileAssetModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'fiscal-year',
    loadChildren: () => import('./pages/laboratory-area/fiscal-year/fiscal-year.module').then((m) => m.FiscalYearModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'laboratory-area/home',
    loadChildren: () => import('./pages/laboratory-area/home-laboratory/home-laboratory.module').then((m) => m.HomeLaboratoryModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'invoice',
    loadChildren: () => import('./pages/laboratory-area/invoice/invoice.module').then((m) => m.InvoiceModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'item',
    loadChildren: () => import('./pages/laboratory-area/item/item.module').then((m) => m.ItemModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'item/family',
    loadChildren: () => import('./pages/laboratory-area/family/family.module').then((m) => m.FamilyModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'journal',
    loadChildren: () => import('./pages/laboratory-area/journal/journal.module').then((m) => m.JournalModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'admin/laboratory',
    loadChildren: () => import('./pages/admin/laboratory/laboratory.module').then((m) => m.LaboratoryModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'api-credential',
    loadChildren: () => import('./pages/laboratory-area/api-credential/api-credential.module').then((m) => m.ApiCredentialModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'laboratory-role',
    loadChildren: () => import('./pages/laboratory-area/laboratory-role/laboratory-role.module').then((m) => m.LaboratoryRoleModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'manufacturer',
    loadChildren: () => import('./pages/laboratory-area/manufacturer/manufacturer.module').then((m) => m.ManufacturerModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'resource',
    loadChildren: () =>
      import('./pages/laboratory-area/laboratory-resource/laboratory-resource.module').then((m) => m.LaboratoryResourceModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'resource/sector',
    loadChildren: () => import('./pages/laboratory-area/sector/sector.module').then((m) => m.SectorModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'patient',
    loadChildren: () => import('./pages/laboratory-area/patient/patient.module').then((m) => m.PatientModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'payment',
    loadChildren: () => import('./pages/laboratory-area/payment/payment.module').then((m) => m.PaymentModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'preview',
    loadChildren: () => import('./pages/laboratory-area/preview/preview.module').then((m) => m.PreviewModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'production-flow',
    loadChildren: () => import('./pages/laboratory-area/production-flow/production-flow.module').then((m) => m.ProductionFlowModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'purchase-invoice',
    loadChildren: () => import('./pages/laboratory-area/purchase-invoice/purchase-invoice.module').then((m) => m.PurchaseInvoiceModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'rate',
    loadChildren: () => import('./pages/laboratory-area/rate/rate.module').then((m) => m.RateModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'raw-material/category',
    loadChildren: () => import('./pages/laboratory-area/category/category.module').then((m) => m.CategoryModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'raw-material',
    loadChildren: () => import('./pages/laboratory-area/raw-material/raw-material.module').then((m) => m.RawMaterialModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'shade',
    loadChildren: () => import('./pages/laboratory-area/shade/shade.module').then((m) => m.ShadeModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'shade/shade-guide',
    loadChildren: () => import('./pages/laboratory-area/shade-guide/shade-guide.module').then((m) => m.ShadeGuideModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'subscription',
    loadChildren: () => import('./pages/laboratory-area/subscription/subscription.module').then((m) => m.SubscriptionModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'user-laboratory',
    loadChildren: () => import('./pages/laboratory-area/user-laboratory/user-laboratory.routes').then((m) => m.USER_LABORATORY_ROUTES),
    canActivate: [AuthGuardWithForcedLogin],
  },
  {
    path: 'user-management',
    loadChildren: () => import('./pages/laboratory-area/user-management/user-management.module').then((m) => m.UserManagementModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // admin
  {
    path: 'admin/user',
    loadChildren: () => import('./pages/admin/user/user.module').then((m) => m.UserModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // url-redirector : link from a production flow/invoice document
  {
    path: 'u',
    loadChildren: () => import('./pages/url-redirector/url-redirector.module').then((m) => m.UrlRedirectorModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // url-switch : used to switch between different areas (customers and/or laboratories)
  {
    path: 'url-switch',
    loadChildren: () => import('./pages/url-switch/url-switch.module').then((m) => m.UrlSwitchModule),
    canActivate: [AuthGuardWithForcedLogin],
  },
  // others
  {
    path: '**',
    redirectTo: 'home',
  },
];
